// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-4b086ad6]{overflow:hidden}.action-btn[data-v-4b086ad6]{position:fixed;bottom:30px}[dir=ltr] .action-btn[data-v-4b086ad6]{right:60px}[dir=rtl] .action-btn[data-v-4b086ad6]{left:60px}", ""]);
// Exports
module.exports = exports;
